import { useEffect, useState } from "react";
import { RotateCcw, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, errorMessage } from "../lib/api";

export const TrashDialog = ({ open, onClose, onRestored }) => {
  const [items, setItems] = useState(null);
  const [confirmId, setConfirmId] = useState(null);
  const load = () => api.get("/projects/trash").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => {
    if (open) load();
  }, [open]);

  const act = async (fn, msg) => {
    try {
      await fn();
      toast.success(msg);
      load();
      onRestored();
    } catch (e) {
      toast.error(await errorMessage(e));
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="trash-dialog" className="bg-[#181B21] border-[#2D333F] max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><Trash2 className="w-5 h-5 text-[#E67E22]" /> Lixeira</DialogTitle>
          <DialogDescription>Ambientes excluídos ficam aqui por 7 dias e depois são apagados de vez.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 max-h-[60vh] overflow-y-auto">
          {items?.length === 0 && <p data-testid="trash-empty" className="text-sm text-[#9CA3AF] py-6 text-center">A lixeira está vazia.</p>}
          {items?.map((p, i) => (
            <div key={p.id} data-testid={`trash-item-${i}`} className="flex flex-wrap items-center gap-3 rounded-lg border border-[#2D333F] bg-[#0F1115] px-4 py-3">
              <div className="min-w-0 flex-1">
                <p className="font-semibold truncate">{p.client || "Sem cliente"} {p.name}</p>
                <p className="text-[11px] text-[#9CA3AF]">{p.piece_count} peças{p.owner_name ? ` · ${p.owner_name}` : ""} · <span data-testid={`trash-days-${i}`} className="text-[#F39C12]">apaga em {p.days_left} dia(s)</span></p>
              </div>
              <Button size="sm" variant="outline" data-testid={`trash-restore-${i}`} onClick={() => act(() => api.post(`/projects/${p.id}/restore`), "Ambiente restaurado")}
                className="border-[#2D333F] bg-transparent"><RotateCcw className="w-4 h-4 mr-1" /> Restaurar</Button>
              <Button size="sm" data-testid={`trash-delete-${i}`} onClick={() => (confirmId === p.id
                ? act(() => api.delete(`/projects/${p.id}/permanent`), "Excluído definitivamente")
                : setConfirmId(p.id))}
                className="bg-red-600 hover:bg-red-700 text-white"><Trash2 className="w-4 h-4 mr-1" /> {confirmId === p.id ? "Confirmar exclusão" : "Excluir de vez"}</Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
